<template>
    <div class="text-start">
        <div class="mb-3">{{ message }}</div>
        
        <div style="max-height: 200px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 5px;">
            <ul class="list-group list-group-flush mb-0">
                
                <li v-for="user in groupedUsers" :key="user.extension" class="list-group-item text-start" style="font-size: 14px; padding: 10px;">
                    <strong><i class="fas fa-user text-secondary"></i> {{ user.name }}</strong> 
                    <span class="badge bg-primary ms-1">Ramal: <span class="text-white">{{ user.extension }}</span></span>
                    
                    <div class="mt-2 text-muted">
                        <div style="font-size: 12px; font-weight: 600; margin-bottom: 4px;">
                            <i class="fas fa-headset"></i> Filas logadas:
                        </div>
                        <ul style="padding-left: 20px; margin-bottom: 0; font-size: 12px;">
                            <li v-for="(q, idx) in user.queues" :key="idx">
                                {{ q.queue }} <span style="font-size: 11px;">(Login: {{ q.login_time }})</span>
                            </li>
                        </ul>
                    </div>
                </li>
                
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoggedUsersList',
    props: {
        message: {
            type: String,
            required: true
        },
        users: {
            type: Array,
            required: true
        }
    },
    computed: {
        // Agrupa o array bruto pelo ramal (extension)
        groupedUsers() {
            const grouped = {};
            
            this.users.forEach(u => {
                if (!grouped[u.extension]) {
                    grouped[u.extension] = {
                        name: u.name,
                        extension: u.extension,
                        queues: [] // Prepara o array de filas para este usuário
                    };
                }
                
                // Adiciona a fila na lista do usuário correspondente
                grouped[u.extension].queues.push({
                    queue: u.queue,
                    login_time: u.login_time
                });
            });
            
            // Retorna apenas os valores do objeto como um array
            return Object.values(grouped);
        }
    }
}
</script>